import "../../../../../styles/profile/in-progress.less";

import { useContext } from "react";

import { Typography } from "antd";
import { AppContext } from "App";
import inProgressIcon from "assets/images/new-questionnaire/clientProfile/in_progress_icon.svg";
import { useNavigate } from "react-router-dom";
import { IClientDocument } from "types/client";

type InProgressTaxProps = {
    currentDocument: IClientDocument
};
export default function InProgress({ currentDocument }: InProgressTaxProps) {
    const { isMobile } = useContext(AppContext);
    const navigate = useNavigate();
    const progressStatus = currentDocument?.answersOB?.shouldComplete ? "In Progress" : "Submitted";
    return (
        <div>
            <img src={inProgressIcon} alt="In Progress" className="display-flex mAuto" width={isMobile ? "35%" : ""}/>
            <Typography className="in-progress__title">
                    Your Tax Return Progress
            </Typography>
            <div className="in-progress__value">
                <div>Stay on track with your self-assessment!</div>
            </div>
            <div>
                <Typography className="in-progress__title">
                    Progress Summary
                </Typography>
                <div className="in-progress__client-details">
                    <div className="in-progress__text-black">Current Status</div>
                    <div className="in-progress__value">
                        <div>{progressStatus}</div>
                    </div>
                </div>
                <div className="in-progress__client-details">
                    <div className="in-progress__text-black">Deadline</div>
                    <div className="in-progress__value">
                        <div>31st January 2025</div>
                    </div>
                </div>
                <button className="shared__primary-button mt20"
                    onClick={() => navigate("/questionnaire")}>
                                Continue Filing
                </button>
            </div>
        </div>
    );
}
